var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenstrual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1513 12.5659C13.6299 12.6119 14.1128 12.5513 14.5653 12.3884C15.0179 12.2255 15.4289 11.9643 15.7689 11.6235C16.1088 11.2827 16.3695 10.8709 16.5321 10.4173C16.8342 9.57463 16.8342 8.42567 16.5321 7.58297C16.3695 7.12944 16.1088 6.71755 15.7689 6.3768C15.4289 6.03603 15.0179 5.77484 14.5653 5.61191C14.1128 5.44899 13.6299 5.38835 13.1513 5.43437C9.88988 5.43437 8.11093 12.5659 4.8495 12.5659C4.37085 12.6119 3.88798 12.5513 3.43545 12.3884C2.98293 12.2255 2.57195 11.9643 2.23193 11.6235C1.89193 11.2827 1.63131 10.8709 1.46874 10.4173C1.16667 9.57463 1.16667 8.42567 1.46874 7.58297C1.63131 7.12944 1.89193 6.71755 2.23193 6.3768C2.57195 6.03603 2.98293 5.77484 3.43545 5.61191C3.88798 5.44899 4.37085 5.38835 4.8495 5.43437C8.11093 5.43437 9.88988 12.5659 13.1513 12.5659Z",
    stroke: "black",
    strokeWidth: 1.29,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenstrual);
export default __webpack_public_path__ + "static/media/menstrual.9bf558044a76d4b83cf5445573f54fb3.svg";
export { ForwardRef as ReactComponent };